const initialState = {
  templates: [],
  starters: [],
  departments: [],
  isLoading: false,
  isSaving: false,
  error: false,
  errorMessage: '',
};

const errorFrom = (action, fallback) => action.payload?.response?.data?.error || fallback;

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case 'BEGIN_GET_REFERRAL_TEMPLATES':
      return {
        ...state, isLoading: true, error: false, errorMessage: '',
      };
    case 'FINISH_GET_REFERRAL_TEMPLATES':
      return {
        ...state,
        isLoading: false,
        templates: action.payload.data.referral_templates || [],
        starters: action.payload.data.starter_templates || [],
        departments: action.payload.data.departments || [],
      };
    case 'FAILED_GET_REFERRAL_TEMPLATES':
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: errorFrom(action, 'Failed to load referral templates'),
      };

    case 'BEGIN_CREATE_REFERRAL_TEMPLATE':
    case 'BEGIN_UPDATE_REFERRAL_TEMPLATE':
    case 'BEGIN_DELETE_REFERRAL_TEMPLATE':
    case 'BEGIN_ARCHIVE_REFERRAL_TEMPLATE':
    case 'BEGIN_UNARCHIVE_REFERRAL_TEMPLATE':
    case 'BEGIN_DUPLICATE_REFERRAL_TEMPLATE':
    case 'BEGIN_DUPLICATE_STARTER_TEMPLATE':
      return {
        ...state, isSaving: true, error: false, errorMessage: '',
      };

    case 'FINISH_CREATE_REFERRAL_TEMPLATE':
    case 'FINISH_UPDATE_REFERRAL_TEMPLATE':
    case 'FINISH_DELETE_REFERRAL_TEMPLATE':
    case 'FINISH_ARCHIVE_REFERRAL_TEMPLATE':
    case 'FINISH_UNARCHIVE_REFERRAL_TEMPLATE':
    case 'FINISH_DUPLICATE_REFERRAL_TEMPLATE':
    case 'FINISH_DUPLICATE_STARTER_TEMPLATE':
      // The component refetches the list after a successful mutation so the
      // templates array stays authoritative (handles add/remove/rename uniformly).
      return { ...state, isSaving: false };

    case 'FAILED_CREATE_REFERRAL_TEMPLATE':
    case 'FAILED_UPDATE_REFERRAL_TEMPLATE':
    case 'FAILED_DELETE_REFERRAL_TEMPLATE':
    case 'FAILED_ARCHIVE_REFERRAL_TEMPLATE':
    case 'FAILED_UNARCHIVE_REFERRAL_TEMPLATE':
    case 'FAILED_DUPLICATE_REFERRAL_TEMPLATE':
    case 'FAILED_DUPLICATE_STARTER_TEMPLATE':
      return {
        ...state,
        isSaving: false,
        error: true,
        errorMessage: errorFrom(action, 'Something went wrong. Please try again.'),
      };

    default:
      return state;
  }
};
